// extracted by mini-css-extract-plugin
module.exports = {"error":"errorText_error__2AnsW"};